import React from "react";

import { BsChatQuote } from "react-icons/bs";
interface PriseListProps {}

const PriseList: React.FC<PriseListProps> = (props) => {
  const prices = [
    {
      icon: BsChatQuote,
      title: "Công lắp đặt máy lạnh",
      desc: "Từ 1 - 1.5HP: 400.000đ/bộ, Từ 2 - 2.5HP: 500.000đ/bộ",
    },
    {
      icon: BsChatQuote,
      title: "Vệ sinh, bảo trì, bảo dưỡng máy lạnh",
      desc: "Từ 170.000đ/bộ (bao gồm đầu lạnh và dàn nóng)",
    },
    {
      icon: BsChatQuote,
      title: "Công lắp máy lạnh âm trần, tủ đứng",
      desc: "2–3HP – 600.000đ/bộ, 4–5HP – 800.000đ/bộ",
    },
    {
      icon: BsChatQuote,
      title: "Vệ sinh máy lạnh âm trần, tủ đứng",
      desc: "2–3HP – 450.000đ/bộ, 4–5HP – 500.000đ/bộ",
    },
    {
      icon: BsChatQuote,
      title: "Công tháo + lắp (di dời) máy lạnh",
      desc: "Từ 550.000đ/bộ",
    },
    {
      icon: BsChatQuote,
      title: "Công kiểm tra, sửa máy",
      desc: "Từ 200.000đ/lần",
    },
    {
      icon: BsChatQuote,
      title: "Công âm tường ống đồng",
      desc: "40.000đ/m",
    },
    {
      icon: BsChatQuote,
      title: "Công kiểm tra, nạp gas",
      desc: "Từ 150.000đ/bộ (Tùy theo lượng gas cần bổ sung)",
    },
  ];
  return (
    <section
      id="price-list"
      className="bg-primary_blue  px-4 lg:px-10 text-white py-5"
    >
      <div className="max-w-6xl mx-auto">
        {/* Tiêu đề */}
        <div className="text-center mb-10">
          <p className="text-sm text-white/80">Bảng giá</p>
          <h2 className="text-3xl lg:text-4xl font-bold">
            Bảng giá dịch vụ tham khảo
          </h2>
        </div>

        {/* Grid bảng giá */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          {prices.map((item, index) => (
            <div
              key={index}
              className="bg-white text-gray-900 rounded-xl p-5 flex items-start space-x-4"
            >
              {/* Icon */}
              {/* <div className="bg-primary_blue p-2 rounded-full">{item.icon}</div> */}
              {/* Nội dung */}
              <div>
                <h3 className="font-semibold text-base">{item.title}</h3>
                <p className="text-sm text-gray-600 mt-1">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PriseList;
